import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
  {
    path: 'insureTec',
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
  },
  {
    path: '404',
    loadChildren: () => import('./@theme/error-pages/page-not-found/page-not-found.module').then(m => m.PageNotFoundModule)
  },
  {
    path: '500',
    loadChildren: () => import('./@theme/error-pages/server-error/server-error.module').then(m => m.ServerErrorModule)
  },
  { path: '', redirectTo: 'insureTec', pathMatch: 'full' },
  { path: '**', redirectTo: '404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
